import React from 'react';
import * as styles from './loader.module.scss';

export default class Loader extends React.Component {
    render() {
        return (
            <div className={`${styles.loader_container} ${this.props.className} `}>
                <div className={styles.lds_spinner}>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        );
    }
}